import { compact } from 'lodash';
import { Editor as SlateEditor } from 'slate';

import {
  getCharactersPointsBoundaries,
  getParagraphsCharacterPoints,
  getSlateRangeText,
  getSlateTopLevelNodes,
} from 'src/lib/slate';

const getCharBoundaries = (charsData, paragraph, start, end) => {
  const paragraphChars = charsData[paragraph];
  if (!paragraphChars || paragraphChars.length === 0 || !(start >= 0 && end >= 0)) {
    return null;
  }

  return getCharactersPointsBoundaries(paragraphChars, start, end);
};

export const contentMarkupToRangeRefs = ({ editor, markup }, options = null) => {
  if (!markup || markup.length === 0) {
    return [];
  }

  const result = [];
  const paragraphs = getSlateTopLevelNodes(editor);
  const charsData = getParagraphsCharacterPoints({ editor, paragraphs: [...paragraphs] }, options);

  markup.forEach(({ type, paragraph, start, end }) => {
    const boundaries = getCharBoundaries(charsData, paragraph, start, end);
    if (!boundaries?.start || !boundaries.end) {
      return;
    }

    const rangeRef = SlateEditor.rangeRef(
      editor,
      {
        anchor: boundaries.start,
        focus: boundaries.end,
        decoration: type,
      },
      { affinity: 'inward' }
    );
    result.push(rangeRef);
  });

  return result;
};

export const rangeRefsToContentMarkup = (editor, rangeRefs) => {
  if (!rangeRefs || rangeRefs.length === 0) {
    return [];
  }

  const paragraphs = [...getSlateTopLevelNodes(editor)];

  return compact(
    rangeRefs.map((rangeRef) => {
      const range = rangeRef?.current;
      if (!range || !range.anchor || !range.focus) {
        return null;
      }

      const paragraphIndex = range.anchor.path[0];
      if (paragraphIndex === -1) {
        return null;
      }

      const paragraphBlockEntry = paragraphs[paragraphIndex];
      const paragraphStart = SlateEditor.start(editor, paragraphBlockEntry[1]);

      const beforeText = getSlateRangeText(editor, {
        anchor: paragraphStart,
        focus: range.anchor,
      });
      const rangeText = getSlateRangeText(editor, range);

      const start = beforeText.length;
      const end = start + rangeText.length;

      return {
        type: range.decoration,
        paragraph: paragraphIndex,
        start,
        end,
      };
    })
  );
};
